var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.styles),on:{"click":_vm.back}},[_c('div',{class:_vm.innerClasses},[_c('Icon',{attrs:{"type":"ios-arrow-down"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }